import { GroupedServiceOverview } from 'src/app/utils/collected-services.utils';

export enum ServiceFilter {
  ALL = 'all',
  SCHEDULED = 'scheduled',
  CONNECTED = 'connected'
}

export interface CollectedServicesStateModel {
  from: Date;
  to: Date;
  selected: Date;
  groupedServiceOverview: GroupedServiceOverview[];
  loading: boolean;
  error: boolean;
  filter: ServiceFilter;
  isHourlyView: boolean;
}
